import { AffiliateFeeView, AffiliateRates } from "../../interfaces/affiliate";

export interface ScenarioSummary {
  id: string;
  name: string;
  generation: number;
  clock: string;
  created_at: string;
  trades: number;
  fills: number;
  simulated: true;
}

export interface ScenarioTrade {
  id: string;
  at: string;
  request: {
    wallet: string;
    instrument_id: string;
    notional: string;
    premium: string;
    fills: number;
    side: "maker" | "taker";
    staking_discount: string;
  };
  paid_fee: string;
  waived_fee: string;
  cash_usd: string;
  dao_usd: string;
  points: string;
}

export interface ScenarioView {
  id: string;
  name: string;
  generation: number;
  clock: string;
  created_at: string;
  simulated: true;
  real_funds_moved: false;
  applied_request_ids: string[];
  summary: Record<string, string>;
  fixtures: {
    affiliate: string;
    trader: string;
    traders: string[];
    code: string;
  };
  instruments: {
    id: string;
    name: string;
    product: "perpetual" | "option";
    expiry?: string;
  }[];
  trades: ScenarioTrade[];
  dashboard: {
    waiver_policy?: string;
    affiliate: { tier: string };
    balances: {
      cash_eligible_usd: string;
      cash_held_usd: string;
      dao_value_usd: string;
      available_points: string;
      pending_points: string;
    };
    decisions: { key: string; value: string; provisional: boolean }[];
  };
  account: {
    rates: AffiliateRates;
    perp_taker: AffiliateFeeView;
    allowance_remaining_usd: string;
    edit_locked_until?: string;
  };
  ledger: {
    points: { kind: string; original: string; remaining: string }[];
    allowances: { original_usd: string; remaining_usd: string }[];
  };
  simulated_payouts: { cash_usd: string; status: string }[];
}

export type ScenarioOperation =
  | "create"
  | "reset"
  | "advance_clock"
  | "define_instrument"
  | "trade"
  | "program"
  | "simulate_payout";

export interface ScenarioCommand {
  request_id: string;
  scenario_id: string;
  operation: ScenarioOperation;
  payload: Record<string, unknown>;
}

export const scenarioID = () => {
  const bytes = window.crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] % 16) + 64;
  bytes[8] = (bytes[8] % 64) + 128;
  const hex = Array.from(bytes, (value) => value.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4),
    hex.slice(4, 6),
    hex.slice(6, 8),
    hex.slice(8, 10),
    hex.slice(10),
  ]
    .map((part) => part.join(""))
    .join("-");
};
